import React, { useContext, useState } from 'react';
import Page from '../../Component/Page/Page';
import LoginForm from "./LoginForm";
import { Alert, Col, Row } from 'antd';
import { Navigate } from 'react-router-dom';
import { GlobalContext } from '../../Contexts/GlobalContext';

interface LoginPageProps {
  originalLocation?: any;
}

export default function LoginPage (props: LoginPageProps) {
  const { originalLocation } = props;
  const [error, setError] = useState({ message: undefined });
  const context = useContext(GlobalContext);

  if (context.user) {
    return <Navigate to={'/'} replace />
  }

  // @ts-ignore
  return (
    <Page {...props} title={'Login'} hideCounter isPublic>
      <Row style={{ padding: '20px 20px' }}>
        <Col sm={24} md={10}>
          {error?.message && <Alert message={error.message} type="error" showIcon />}
        </Col>
      </Row>

      <LoginForm originalLocation={originalLocation} setError={setError} />
    </Page>
  );
}
